import React, {ReactNode} from 'react'
import tw from 'tailwind-styled-components'
import {DataObjectId} from 'yougile-model'
import {Icon} from '@components/common/base/icon'
import {ChatUtils} from '@extensions/chat-utils'
import {useStore} from './parent-tasks-store'
import {ShowParentTasks} from './show-parent-tasks'

const TwTaskContainer = tw.div`
    relative
    cursor-pointer

    border-solid
    border
    border-grey-l60
    rounded-4
    bg-grey-l100
    min-h-32

    pl-8
    py-8

    flex
    items-start
    justify-start
    mb-8
`

const TwText = tw.div`
  text-sm-regular
  text-primary
`

export const ParentTask = (props: {
  id: DataObjectId
  title: string | ReactNode
  isParent: boolean
  isCompleted: boolean
  isDeal?: boolean
  className?: string
}) => {
  const [state, store] = useStore()

  return (
    <TwTaskContainer
      data-test="BarTwTaskContainer"
      className={props.className}
      onClick={e => {
        e.stopPropagation()
        ChatUtils.openChatById(props.id)
      }}
    >
      {!props.isDeal && (
        <Icon
          icon={props.isCompleted ? 'IconCircleCheckFilled' : 'IconCircleCheck'}
          color={props.isCompleted ? 'success' : 'secondary'}
          className={'mr-8'}
        />
      )}
      {props.isParent && (
        <ShowParentTasks
          opened={state.opened.has(props.id)}
          onToggle={() => store.toggleOpen(props.id)}
          className="align-middle"
        />
      )}
      {typeof props.title === 'string' ? (
        <TwText>{props.title}</TwText>
      ) : (
        props.title
      )}
    </TwTaskContainer>
  )
}
